import {REPORT_NEW_COACHES_IN_ORGANIZATION} from '/enum/records.enum';

export default {
  reportName: REPORT_NEW_COACHES_IN_ORGANIZATION,
};
